import { CSSProperties } from 'react';

export const container: CSSProperties = {
  backgroundColor: '#B4FF00',
  position: 'relative',
  width: '100%',
};

export const body: CSSProperties = {
  position: 'relative',
  margin: 'auto',
  width: 360,
  zIndex: 100,
};

export const topDee: CSSProperties = {
  backgroundColor: '#BE63FF',
  height: 6,
  left: 0,
  position: 'absolute',
  right: 0,
  top: 0,
  zIndex: 10,
};
